import { SxProps } from '@mui/material';
import { red2 } from 'app/components/ThemeProvider/colors';

export const wrapper: SxProps = {
  marginTop: '8px',
  color: red2,
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: 1,
  fontFamily: 'Yelo',
};
